<div
  class="toaster-by-subject toast"
  [class.toast--open]="isOpen"
  [class.toast--closed]="!isOpen"
  [ngClass]="'toast--' + intent"
>
  <div class="toast__type-indicator">
    <cp-icon [type]="intentIcon"></cp-icon>
  </div>
  <div class="toast__content">
    <div class="toast__header">
      <div class="toast__message">
        <p class="toast__title" [class.toast--align-left]="subtext">
          {{ title }}
          <a
            class="toast__action-link toast__title-action-link"
            *ngIf="customTitleLink"
            (click)="handleCustonTitleLinkAction()"
          >
            {{ customTitleLink.label }}
          </a>
          <a
            class="toast__action-link"
            [ngClass]="'toast__action-link--' + intent"
            *ngIf="hasActionLink"
            (click)="performNamedAction(actionType)"
          >
            {{ linkLabel }}
          </a>
        </p>
        <p class="toast__description">
          {{ description }}
        </p>
        <p *ngIf="subtext" class="toast__subtext">
          {{ subtext }}
        </p>
        <a
          class="toast__action-link toast__action-link--success"
          *ngIf="customSubtextLink"
          (click)="handleCustomSubtextLinkAction()"
        >
          {{ customSubtextLink.label }}
        </a>
      </div>
    </div>
  </div>

  <button class="toast__close-button" *ngIf="hasCloseButton" (click)="customClose()">
    <cp-icon type="close-xs"></cp-icon>
  </button>
</div>
